import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Home/Hero';
import { MultiSectorExcellence } from '../components/Home/MultiSectorExcellence';
import { HowWeWorkSection } from '../components/Home/HowWeWorkSection';
import { AchievementsSection } from '../components/Home/AchievementsSection';
import { TrustedClientsSection } from '../components/Home/TrustedClientsSection';
import { EnhancedTestimonialsSection } from '../components/Home/EnhancedTestimonialsSection';
import { CTASection } from '../components/Home/CTASection';

export const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Hero />
      <MultiSectorExcellence />
      <HowWeWorkSection />
      <AchievementsSection />
      <TrustedClientsSection />
      <EnhancedTestimonialsSection />
      <CTASection />
    </motion.div>
  );
};